<script>
    let old_tags_filename;
    let tags_filename;
    let tags_rows = [];
    let loading = false;
    let saving = false;
    let savingCopy = false;
    let saveResponse = {};
    let saveCopyResponse = {};

    import { onMount } from "svelte";
    import Tags from "../components/Tags.svelte";
    import { getContext } from "svelte";
    import { api_info, fetchWithAuthentication } from "../api/client.js";
    import { nextId } from "../components/id_generator";
    import SectionButton from "../components/SectionButton.svelte";
    import ResultMessage from "../components/ResultMessage.svelte";
    const context = getContext(api_info);

    async function getTags() {
        loading = true;
        const response = await fetchWithAuthentication(context, "/get_tags/", {
            tags_collection_name: old_tags_filename,
        });
        tags_rows = response.tags.map((x) =>
            x.map((y) => ({ id: nextId(), value: y }))
        );
        loading = false;
    }

    function onTags(tags, row) {
        if (tags.length === 0) {
            // clean up empty rows
            tags_rows.splice(row, 1);
            tags_rows = tags_rows;
        } else {
            tags_rows[row] = tags;
        }
    }

    function addNewRow() {
        tags_rows = [...tags_rows, []];
    }

    function getTagRows() {
        return tags_rows
            .map((row) => row.map((tag) => tag.value))
            .filter((row) => row.length > 0);
    }

    async function save() {
        saveResponse = undefined;
        saving = true;
        saveResponse = await fetchWithAuthentication(context, "/save_tags/", {
            old_tags_collection_name: old_tags_filename,
            new_tags_collection_name: tags_filename,
            tags: getTagRows(),
        });
        saving = false;
        // clean up empty row
        tags_rows = tags_rows.filter((row) => row.length > 0);
    }

    async function saveCopy() {
        saveCopyResponse = undefined;
        savingCopy = true;
        saveCopyResponse = await fetchWithAuthentication(
            context,
            "/save_new_tags/",
            {
                tags_collection_name: tags_filename,
                tags: getTagRows(),
            }
        );
        savingCopy = false;
    }

    onMount(() => {
        const params = new URLSearchParams(window.location.search);
        old_tags_filename = params.get("tag");
        tags_filename = old_tags_filename;

        getTags();
    });
</script>

<form class="form-horizontal">
    <div class="form-group">
        <label for="version" class="col-sm-2 control-label"
            >เวอร์ชันป้ายกำกับ</label
        >
        <div class="col-sm-10">
            <input
                type="text"
                class="form-control"
                id="version"
                bind:value={tags_filename}
            />
        </div>
    </div>
    <div class="form-group">
        {#if loading}
            <div class="col-sm-offset-3">
                <span class="glyphicon glyphicon-refresh spinning" /> กำลังโหลดข้อมูล
            </div>
        {:else}
            <label class="col-sm-2 control-label">ป้ายกำกับ</label>
            <div class="col-sm-10">
                {#each tags_rows as tags_row, index (tags_row)}
                    <Tags
                        highlightFirstTag={true}
                        tags={tags_row}
                        on:tags={(e) => onTags(e.detail.tags, index)}
                    />
                {/each}
                <button
                    type="button"
                    class="btn btn-default"
                    on:click={addNewRow}
                >
                    <span class="glyphicon glyphicon-plus" />
                </button>
            </div>
        {/if}
    </div>
    <SectionButton label="บันทึก" offset={2} loading={saving} on:click={save}>
        <ResultMessage response={saveResponse} />
    </SectionButton>
    <SectionButton
        label="บันทึกสำเนา"
        offset={2}
        loading={savingCopy}
        on:click={saveCopy}
    >
        <ResultMessage response={saveCopyResponse} />
    </SectionButton>
</form>
